import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    card: {
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    logo: {
      display: "block",
    },
    subtitle: {
      color: theme.text.secondary,
    },
    rowClickable: {
      cursor: "pointer",
    },
    rowOuter: {
      justifyContent: "space-between",
      alignItems: "center",
    },
    rowInner: {
      alignItems: "center",
      flex: 1,
      minWidth: 0,
    },
    pdfIcon: {
      flexShrink: 0,
      marginRight: spacing.s,
    },
    rowLabel: {
      color: theme.text.secondary,
    },
  };

  return styles;
};
